export default "__VITE_ASSET__cf_iwP_e__"